<template>
  <div>
    <b-badge
      style="float: left; width: 20%"
      :key="index"
      v-for="(item, index) in resimlerList"
    >
      <vs-card>
        <img
          style="width: 100%"
          :src="cevir(item.STOCKPICTURE)"
          class="grid-view-img px-4"
        />
      </vs-card>
    </b-badge>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      resimlerList: [],
    };
  },
  methods: {
    cevir(data) {
      var srcBase64 = "data:image/jpeg;base64," + btoa(atob(data));
      return srcBase64;
    },
    resimList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_Resim(args, function (err, result) {
          if (result.INT_Ls_Stock_ResimResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Stock_ResimResult);
          vm.resimlerList = vm.veriler;
          console.log(vm.veriler)
          // vm.rowData = vm.veriler;
        });
      });
    },
  },
  created() {
    this.resimList();
  },
};
</script>